import { Navigate, useLocation } from "react-router-dom";
import { loginUrlWithNext } from "../../lib/safe-redirect";
import { useAuthStore } from "../../stores/auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated) {
    // Girişten sonra kalınan sayfaya dönülsün.
    return <Navigate to={loginUrlWithNext(location)} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
